import { render, staticRenderFns } from "./tabHrRealGpReport.vue?vue&type=template&id=638fe530&"
import script from "./tabHrRealGpReport.vue?vue&type=script&lang=js&"
export * from "./tabHrRealGpReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('638fe530')) {
      api.createRecord('638fe530', component.options)
    } else {
      api.reload('638fe530', component.options)
    }
    module.hot.accept("./tabHrRealGpReport.vue?vue&type=template&id=638fe530&", function () {
      api.rerender('638fe530', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/PillReport/tabHrRealGpReport.vue"
export default component.exports